import { Editor, EditorState } from "draft-js";
import React from "react";

import useRichTextEditorPresenter from "@Components/shared/RichTextEditor/hooks/useRichTextEditorPresenter";
import Controls from "@Components/shared/RichTextEditor//Controls";

import "@Components/shared/RichTextEditor/richTextEditor.scss";
import "draft-js/dist/Draft.css";

/**
 * Props for the RichTextEditor component.
 */
interface IProps {
    onChange?: (content: string) => void;
    initialContent?: EditorState;
    placeholder?: string;
}

/**
 * RichTextEditor component that provides a rich text editing experience.
 */
const RichTextEditor = ({ onChange, initialContent, placeholder = "" }: IProps) => {
    const { editorState, uiModel, handlers } = useRichTextEditorPresenter({
        onChange,
        initialContent,
    });

    return (
        <div className="rich-text-editor-root">
            <Controls editorState={editorState} handlers={handlers} />
            <div className={uiModel.className} onClick={handlers.focus}>
                <Editor
                    editorState={editorState}
                    handleKeyCommand={handlers.handleKeyCommand}
                    onChange={handlers.handleChange}
                    placeholder={placeholder}
                    ref={uiModel.editor}
                    spellCheck={false}
                    blockStyleFn={uiModel.blockStyleFn}
                />
            </div>
        </div>
    );
};

export default RichTextEditor;
